import React from "react";
import { Users, ShieldCheck, Smartphone, School } from "lucide-react";
import PageWrapper from "../components/PageWrapper";
import PageHero from "../components/PageHero";
import BusImage from "../components/BusImage";
import FeatureCard from "../components/FeatureCard";

const features = [
  {
    icon: Users,
    title: "Experienced Team",
    description:
      "Trained drivers, attendants, and operations professionals with deep domain expertise in school transport.",
  },
  {
    icon: ShieldCheck,
    title: "Safety-Focused Operations",
    description:
      "Strict safety protocols, regular vehicle checks, and continuous training ensure every child's journey is safe.",
  },
  {
    icon: Smartphone,
    title: "Technology-Enabled Visibility",
    description:
      "Live GPS tracking, automated alerts, and real-time dashboards provide complete transparency to schools and parents.",
  },
  {
    icon: School,
    title: "School-Centric Service",
    description:
      "We work as an extension of your school, aligning with your values, policies, and operational standards.",
  },
];

const About = () => {
  return (
    <PageWrapper testId="about-page">
      <PageHero
        title={
          <>
            A Trusted Partner for
            <br />
            School Transport{" "}
            <span className="brand-blue">Operations</span>
            <span className="text-amber-500">.</span>
          </>
        }
        description="MDST Travels School Transport professionally manages school bus operations for schools across India. We combine trained staff, operational discipline, and smart technology to deliver safe, reliable, and transparent transportation every day."
        cta={{ label: "Our Services", to: "/services" }}
        rightContent={<BusImage variant="about" />}
      />

      <section
        className="max-w-[1280px] mx-auto px-5 lg:px-10 -mt-2 mb-14"
        data-testid="about-features"
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((f, i) => (
            <div
              key={f.title}
              className="bg-white border border-slate-200 rounded-2xl p-7 lift relative overflow-hidden"
              data-testid={`about-feature-${i}`}
            >
              <div className="w-14 h-14 rounded-full bg-blue-50 text-[#2563EB] flex items-center justify-center mb-4">
                <f.icon size={26} strokeWidth={2} />
              </div>
              <h3 className="text-[1.05rem] font-extrabold text-[#0F1B2D] leading-snug mb-2">
                {f.title}
              </h3>
              <div className="w-8 h-[3px] bg-amber-400 rounded-full mb-3" />
              <p className="text-[14px] text-slate-600 leading-relaxed">
                {f.description}
              </p>
            </div>
          ))}
        </div>
      </section>
    </PageWrapper>
  );
};

export default About;
